import { SVGProps } from 'react'

export const GroupOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" fill="none" viewBox="0 0 25 24" {...props}>
    <g fill="currentColor" clipPath="url(#clip0_498_3761)">
      <path d="M16.99 13.65c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9a2.988 2.988 0 00-1.76 2.74V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.82 16a.96.96 0 01.49-.52c1.1-.49 2.26-.73 3.43-.73 1.18 0 2.33.25 3.43.73.23.1.4.29.49.52H8.82zM1.97 14.58a2.01 2.01 0 00-1.22 1.85V18h4.5v-1.61c0-.83.23-1.61.63-2.29-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58zM23.53 14.58a6.95 6.95 0 00-2.78-.58c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18h4.5v-1.57c0-.81-.48-1.53-1.22-1.85zM12.75 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM4.75 8.497L2.247 11l2.503 2.503L7.253 11 4.75 8.497zM20.75 9l-2.5 4h5l-2.5-4z"></path>
    </g>
    <defs>
      <clipPath id="clip0_498_3761">
        <path fill="#fff" d="M0 0H24V24H0z" transform="translate(.75)"></path>
      </clipPath>
    </defs>
  </svg>
)
